// extracted by mini-css-extract-plugin
export default {"title":"xj6tebQz0aEnZmugVR3A","titleText":"PUtM4w5gHPur9fnJyXAB","actions":"FvGh5fUvcz5hEfugUuxV","close":"ftoXfiyVUqUWHR3SmxSm","backdrop":"i9w4lzGxaghqRMA4U1BN"};